import { $authHost, $host } from "./index";

/*export const getCatalog = async (user) => {
    try {
        const { data } = await $authHost.get('api/shop/catalog')
        return data
    } catch (e) {
        window.localStorage.removeItem('token');
        user.setToken(null)
        return []
    }
}*/

export const getNewCatalog = async () => {
    try {
        const { data } = await $host.get('api/shop/new/catalog')
        return data
    } catch (e) {
        console.log('ошибка каталога1 productApi getNewCatalog', e)
        return []
    }
}

export const getProducts = async (id, page, pageSize, requestBodyFilter) => {
  try {
//    console.log("запрос newProducts", id, page, pageSize, requestBodyFilter);

    const { data } = await $host.post(
      `api/shop/new/catalog/${id}?page=${page}&pageSize=${pageSize}`, 
      requestBodyFilter
    );
//    console.log("response newProducts", data);
    return data;
  } catch (e) {
    localStorage.clear();
    return [];
  }
};

export const getAllFilters = async (id) => {
  try {
    const { data } = await $host.post(
      `api/shop/new/catalog/filters/${id}`     
    );
    // console.log("response getAllFilters", data);
    return data;
  } catch (e) {
    localStorage.clear();
    return [];
  }
};

export const getAvailableFilters = async (id, requestBodyFilter) => {
  try {
    const { data } = await $host.post(
      `api/shop/new/catalog/filters/available/${id}`, 
      requestBodyFilter     
    );
  //  console.log("response getAvailableFilters", data);
    return data;
  } catch (e) {
    localStorage.clear();
    return [];
  }
};



export const getWholesalePrices = async (productIds) => {
  const { data } = await $authHost.post('api/v1/auth/price/opt', { productIds });
  
  return data.products; // ✅ вот так правильно
};

export const getFavoriteProductsParent = async (id) => {
    try {
        const { data } = await $authHost.get('api/shop/new/catalog/favorite/parent/' + id);
        // 🧠 Расплющиваем favoriteProducts сразу здесь
        const allFavorites = data.flatMap(item => item.favoriteProducts || []);

     return allFavorites;
       
    } catch (e) {
        localStorage.clear()
    //    window.localStorage.removeItem('token');
    //    user.setToken(null)
        return []
    }
}

/* старые продукты.
export const getProducts = async (id, user, product) => {
    try {
        const { data } = await $authHost.post('api/shop/realproductsfolder/' + id, {product})
      //  console.log("response newProducts", data)
        product.setPagination(data.pagination)
        return data.realProducts
    } catch (e) {
        // window.localStorage.removeItem('token');
        localStorage.clear()
        user.setToken(null)
        return []
    }
}*/

export const getProduct = async (id, user) => {
    try {
        const { data } = await $authHost.get('api/shop/realproducts/' + id)
        return data
    } catch (e) {
        window.localStorage.removeItem('token');
        user.setToken(null)
        return []
    }
}
/*
export const getFilters = async (user) => {
    try {
        const { data } = await $host.get('api/shop/catalog/filters')
       // console.log(data)
        return data
    } catch (e) {
        window.localStorage.removeItem('token');
        user.setToken(null)
        return []
    }
}*/

export const createPosting = async (user, products, recipient, address, priceDost, comment) => {
    try {
        const { data } = await $authHost.post('api/shop/posting/create', {user, products, recipient, address, priceDost, comment})
       // console.log("data createPosting", data)

        return data
    } catch (e) {
        alert(e)

        // window.localStorage.removeItem('token');
        // user.setToken(null)
        return []
    }
}

export const createMovePosting = async (user, products, store) => {
    try {
        const { data } = await $authHost.post('api/shop/posting/move', {user, products, store})
        return data
    } catch (e) {
        alert(e)

        // window.localStorage.removeItem('token');
        // user.setToken(null)
        return []
    }
}

//  export const createDelivering = async (user, products, firstName, lastName, phone, address, latitude, longitude, price, comment, store) => {
export const createDelivering = async (user, products, recipient, address, price, comment, store, prr, deliveringDate) => {
    try {
        const { data } = await $authHost.post('api/shop/delivering/create', {user, products, recipient, address, price, comment, store, prr, deliveringDate})
        return data
    } catch (e) {
        alert(e)

        // window.localStorage.removeItem('token');
        // user.setToken(null)
        return []
    }
}

